// eslint-disable-next-line no-restricted-imports
import { LegalClientBodyFragment } from 'api/generated/graphql';
import {
  LegalClientBodyEntity,
  LegalClientBodyType,
} from 'api/types/entity/legal/legalClientBody';
import { lodash } from 'helpers';

export const parseLegalClientBodyEntity = (
  bodies: LegalClientBodyFragment[]
): LegalClientBodyEntity[] | undefined =>
  lodash.compact(bodies).map((v) => ({
    id: v.id,
    type: LegalClientBodyType[v.type],
    name: v.name,
    otherType: v.otherType ?? undefined,
  }));
